import { render, staticRenderFns } from "./date-range-picker.vue?vue&type=template&id=b8d08bfa&scoped=true"
import script from "./date-range-picker.vue?vue&type=script&lang=js"
export * from "./date-range-picker.vue?vue&type=script&lang=js"
import style0 from "./date-range-picker.vue?vue&type=style&index=0&id=b8d08bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d08bfa",
  null
  
)

export default component.exports